import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';

export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).do(undefined,
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 403) {
            console.log('Unauthorized Request - In case of Auth Token Expired');
            const urlLogin = sessionStorage.getItem('urlLogin') ? sessionStorage.getItem('urlLogin') : 'http://www.google.com';
            sessionStorage.clear();
            window.location.href = urlLogin;
          }
        }
      });
  }
}
